var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("UiButton", {
        attrs: { buttonText: _vm.noteButtonText, variant: _vm.buttonVariant },
        on: {
          click: function ($event) {
            _vm.modalShown = true
          },
        },
      }),
      _vm.modalShown
        ? _c(
            "ApplicationNoteModal",
            {
              attrs: {
                currentUserId: _vm.currentUserId,
                applicationId: _vm.applicationId,
                jobTitle: _vm.jobTitle,
                companyName: _vm.companyName,
                location: _vm.location,
                employmentType: _vm.employmentType,
                duration: _vm.duration,
                postedDate: _vm.postedDate,
                description: _vm.description,
                note: _vm.note,
                skills: _vm.skills,
                industries: _vm.industries,
                postingId: _vm.postingId,
                attachedDocumentId: _vm.attachedDocumentId,
                actionButtonText: _vm.actionButtonText,
              },
              on: {
                close: _vm.onModalClose,
                updated: _vm.onUpdate,
                fileUploaded: _vm.onAttachNewFile,
              },
            },
            [
              _c(
                "FormGroup",
                {
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c(
                              "span",
                              { staticClass: "text-gray-600 text-label" },
                              [_vm._v(" My Comments ")]
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    471283844
                  ),
                },
                [
                  _c("FormTextarea", {
                    attrs: { rows: 10, placeholder: "Add comment here" },
                    model: {
                      value: _vm.applicationNote,
                      callback: function ($$v) {
                        _vm.applicationNote = $$v
                      },
                      expression: "applicationNote",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }